import { FC, useEffect, useState } from "react";
import { KTSVG } from "../../_metronic/helpers";
import { useDataTableStore } from "../../stores/DataTableStore";
import { SelectOption } from "../../interfaces/SelectOption";
import { DataTableSelect } from "../DataTable/DataTableSelect";
import { useIntl } from "react-intl";
import { usePipelineStore } from "../../stores/PipelineStore";
import { useSettingsStore } from "../../stores/SettingsStore";
import { Drawer } from "rsuite";
import useCheckIsMobile from "../../hooks/useCheckIsMobile";

const FilterReportProductsSold: FC = () => {
    const intl = useIntl()
    const { selectedFilters, setSelectedFilter, masterDateRange, clearMasterDateRange } = useDataTableStore();
    const { multiPipelines } = usePipelineStore()
    const [leadTemplates, setLeadTemplates] = useState<SelectOption[]>([])
    const { settings } = useSettingsStore()
    const { isMobile } = useCheckIsMobile()
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);

    let selectConfigs = [
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} Database ${settings.pipeline_title}`,
            tableKey: "reportProductsSold",
            filterKey: 'templateId',
            options: leadTemplates,
            onChange: (values: string[]) => setSelectedFilter("reportProductsSold", 'templateId', values)
        }
    ];

    const handleResetFilter = () => {
        setSelectedFilter("reportProductsSold", 'templateId', [])
        if (masterDateRange.reportProductsSold?.startDate && masterDateRange.reportProductsSold?.endDate) {
            clearMasterDateRange()
        }
    }

    useEffect(() => {
        const options = multiPipelines.map(pipeline => ({
            value: pipeline.id,
            label: pipeline.name
        }));

        setLeadTemplates(options);
    }, [multiPipelines]);

    return (
        <div>
            {
                selectedFilters['reportProductsSold']?.templateId?.length > 0 ?
                    <>
                        <button className="btn mt-3 me-3" style={{ backgroundColor: "#f1faff", border: "2px solid #009EF7", padding: "calc(0.75rem) calc(1.5rem)" }} onClick={() => setIsOpenDrawer(true)}>
                            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2 svg-icon-primary m-0' />
                        </button>
                        <button type="button"
                            className="btn btn-white mt-3 text-primary"
                            onClick={() => { handleResetFilter() }}
                        >
                            Reset Filter
                        </button>
                    </>
                    :
                    <button type="button"
                        className="btn btn-light mt-3"
                        onClick={() => setIsOpenDrawer(true)}
                    >
                        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2 m-0' />
                    </button>
            }
            <Drawer
                className="bg-white"
                size={isMobile ? "xs" : "sm"}
                placement="right"
                open={isOpenDrawer}
                onClose={() => setIsOpenDrawer(false)}
                style={{ height: "100%", overflowY: "auto" }}
            >
                <div className="card rounded-0" style={{ height: "100%" }}>
                    <div className="card-header pe-5">
                        <div className="card-title">
                            <div className="d-flex justify-content-center flex-column me-3">
                                <span className="fs-4 fw-bolder text-gray-900 text-hover-primary me-1 lh-1">Filter {intl.formatMessage({ id: 'FORM.LABEL.PRODUCT_SOLD' })}</span>
                            </div>
                        </div>
                        <div className="card-toolbar">
                            <div className="btn btn-sm btn-icon btn-active-light-primary" onClick={() => setIsOpenDrawer(false)}>
                                <span className="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body hover-scroll-overlay-y">
                        <div style={{ fontWeight: "600" }}>Filter Data</div>
                        <div className="separator separator-dashed my-3"></div>
                        {
                            selectConfigs.map((config, index) => (
                                <DataTableSelect
                                    placeholder={config.placeholder}
                                    tableKey={config.tableKey}
                                    filterKey={config.filterKey}
                                    key={index}
                                    options={config.options}
                                    onChange={config.onChange}
                                />
                            ))
                        }
                    </div>
                </div>
            </Drawer>
        </div>
    )
}

export { FilterReportProductsSold }